import { useKernelApi } from 'infrastructure/api';
import { useCrudService } from 'framework/crud';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { LoadingParams } from 'framework/list';
import { RESOURCE_URL as EMPLOYEES_RESOURCE_URL } from 'domain/shared/employee';
import ASSESSMENT_VALIDATION from 'domain/people/employee/assessment/createupdate/assessmentValidation';
export const READ_ASSESSMENTS_LIST = 'READ_ASSESSMENTS_LIST';
export const CREATE_ASSESSMENT = 'CREATE_ASSESSMENT';

const RESOURCE_URL = '/assessments';

const useAssessmentService = () => {
  const { sendGetRequest } = useKernelApi();
  const employeeId = useEmployeeId();
  const listResourceUrl = `${EMPLOYEES_RESOURCE_URL}/${employeeId}${RESOURCE_URL}`;

  const { ...baseAssessmentsMethods } = useCrudService({
    singleResourceUrl: `${RESOURCE_URL}/:id`,
    listResourceUrl: RESOURCE_URL,
    useService: useKernelApi,
  });

  const { create } = useCrudService({
    singleResourceUrl: `${listResourceUrl}/:id`,
    listResourceUrl,
    useService: useKernelApi,
  });

  const getSearchParams = (request: LoadingParams) => {
    const params = [];
    params.push(`pageSize=${encodeURIComponent(request.pageSize)}`);
    params.push(`pageNumber=${encodeURIComponent(request.pageNumber)}`);

    if (request.sort && Object.keys(request.sort).length > 0) {
      const [sortKey, sortValue = ''] = Object.entries(request.sort)[0];
      params.push(`${encodeURIComponent(`sort[${sortKey}]`)}=${encodeURIComponent(sortValue)}`);
    }

    return params.join('&');
  };

  const search = async (request: any) => {
    const url = `${listResourceUrl}?${getSearchParams(request)}`;
    const response = await sendGetRequest(url);

    return response.json();
  };

  const getValidationSchema = () => Promise.resolve(ASSESSMENT_VALIDATION);

  return {
    ...baseAssessmentsMethods,
    getValidationSchema,
    search,
    create,
  };
};

export default useAssessmentService;
